import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bp_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, authHeaders());
  return data;
};

export const fetchEstimates = async () => {
  const { data } = await axios.get(`${API}/estimates`, authHeaders());
  return data;
};

export const updateEstimate = async (id, updates) => {
  const { data } = await axios.patch(`${API}/estimates/${id}`, updates, authHeaders());
  return data;
};

export const deleteEstimate = async (id) => {
  await axios.delete(`${API}/estimates/${id}`, authHeaders());
};

export const fetchAllReviews = async () => {
  const { data } = await axios.get(`${API}/reviews/all`, authHeaders());
  return data;
};

export const updateReview = async (id, updates) => {
  const { data } = await axios.patch(`${API}/reviews/${id}`, updates, authHeaders());
  return data;
};

export const deleteReview = async (id) => {
  await axios.delete(`${API}/reviews/${id}`, authHeaders());
};

export const fetchGallery = async (category) => {
  const { data } = await axios.get(`${API}/gallery/${category}`);
  return data;
};

export const addGalleryImage = async (category, image) => {
  const { data } = await axios.post(`${API}/gallery`, { category, image }, authHeaders());
  return data;
};

export const deleteGalleryImage = async (id) => {
  await axios.delete(`${API}/gallery/${id}`, authHeaders());
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
